import { SVGProps } from "react";

const ImageIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 25, height = 25, fill = "black" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 6.26661C4.5 5.33644 5.25405 4.5824 6.18421 4.5824H18.8158C19.746 4.5824 20.5 5.33644 20.5 6.26661V18.8982C20.5 19.8283 19.746 20.5824 18.8158 20.5824H6.18421C5.25405 20.5824 4.5 19.8284 4.5 18.8982V6.26661ZM6.18421 5.84556C5.95167 5.84556 5.76316 6.03407 5.76316 6.26661V14.5683L7.07951 14.0186C8.71801 13.3343 10.5723 13.3918 12.1653 14.1761C13.3153 14.7423 14.6417 14.8339 15.8586 14.4312L19.2368 13.3133V6.26661C19.2368 6.03407 19.0483 5.84556 18.8158 5.84556H6.18421ZM5.76316 18.8982V15.9372L7.56627 15.1842C8.86819 14.6405 10.3416 14.6861 11.6074 15.3093C13.0546 16.0219 14.7239 16.1372 16.2554 15.6304L19.2368 14.6438V18.8982C19.2368 19.1307 19.0483 19.3192 18.8158 19.3192H6.18421C5.95167 19.3192 5.76316 19.1307 5.76316 18.8982ZM13.1317 9.95092C13.1317 9.4277 13.5558 9.00355 14.079 9.00355C14.6023 9.00355 15.0264 9.4277 15.0264 9.95092C15.0264 10.4741 14.6023 10.8983 14.079 10.8983C13.5558 10.8983 13.1317 10.4741 13.1317 9.95092ZM14.079 7.74039C12.8582 7.74039 11.8685 8.73008 11.8685 9.95092C11.8685 11.1718 12.8582 12.1614 14.079 12.1614C15.2999 12.1614 16.2896 11.1718 16.2896 9.95092C16.2896 8.73008 15.2999 7.74039 14.079 7.74039Z"
        fill={fill}
      />
    </svg>
  );
};

export default ImageIcon;
